import angular from "angular";

function userLoggedOutHeader() {
  return {
    restrict: 'E',
    template: require('./templates/user-logged-out-header.html')
  }
}

export default angular.module('directives.userLoggedOutHeader', []).directive('userLoggedOutHeader', userLoggedOutHeader).name;


// WEBPACK FOOTER //
// ./src/app/directives/userLoggedOutHeader.js